import type { Block } from '../../../../types/proposal-blocks';
import { renderMarkdown } from './markdown';

type Data = Extract<Block, { type: 'conditions' }>;

export function ConditionsBlock({ block }: { block: Data }) {
  return (
    <div className="my-6 bg-proposal-bg2 border border-proposal-border rounded-p-lg p-6">
      <h3 className="text-base font-semibold text-proposal-fg1 mb-4">Condiciones</h3>
      <div className="text-[13px] text-proposal-fg2 leading-relaxed">
        {renderMarkdown(block.markdown)}
      </div>
    </div>
  );
}
